import React, { useEffect, useState } from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { useMytaStreams } from './MytaStreamsProvider';
import { describeNotice } from './spotDrain';

// Spot per client (myta-streams 2026-09-08): everything AWS does to the GPU box behind this session is said out
// loud, over the stream, while it happens — the two-minute reclaim notice with its countdown, the move to a new
// machine, and a machine that is already gone. Renders nothing when there is nothing to say.
const SpotNoticeBanner = () => {
  const { drainNotice, spotNotice } = useMytaStreams();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!drainNotice || drainNotice.kind !== 'interrupt') {
      return undefined;
    }
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [drainNotice]);

  // A live interruption notice counts down every second; every other message is shown as the provider set it.
  const view = drainNotice ? describeNotice(drainNotice, now) : spotNotice;
  if (!view) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1400,
        width: 'min(720px, calc(100vw - 32px))',
        pointerEvents: 'none',
      }}
    >
      <Alert
        severity={view.severity}
        variant="filled"
        sx={{ pointerEvents: 'auto', boxShadow: 6, alignItems: 'flex-start' }}
        data-testid="myta-spot-notice"
      >
        <AlertTitle sx={{ fontWeight: 700 }}>
          {view.title}
          {view.secondsLeft !== undefined ? ` — ${view.secondsLeft} s` : ''}
        </AlertTitle>
        {view.body}
      </Alert>
    </Box>
  );
};

export default SpotNoticeBanner;
